<div class="auth-social">
  <h3 class="auth-social__title">или войти с помощью</h3>
  <div class="auth-social__links">
    <a href="#" class="auth-social__link">
      <app-icon [src]="'assets/images/icons/icon-gosservice.svg'" name="icon-gosservice"></app-icon>
    </a>
    <a href="#" class="auth-social__link">
      <app-icon [src]="'assets/images/icons/icon-email.svg'" name="icon-email"></app-icon>
    </a>
    <a href="#" class="auth-social__link">
      <app-icon [src]="'assets/images/icons/icon-vk.svg'" name="icon-vk"></app-icon>
    </a>
  </div>
</div>
